export default __webpack_public_path__ + "static/media/optionsIcon.3d363960.svg";